module.exports = __webpack_public_path__ + "static/media/NotasFiscais13.bc06d619.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancNotasFiscais/NotasFiscais13.png
// module id = 2144
// module chunks = 0